import { element } from 'protractor';
import { FastTrackService } from './service/fast-track.service';
import { classificationImageToggleComponent } from './element/classificationImageToggle/classificationImageToggle.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Component } from '@angular/core';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './element/header/header.component';
import { FooterComponent } from './element/footer/footer.component';
import { SearchComponent } from './element/search/search.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ContactComponent } from './contact/contact.component';
import { UserService } from './service/user.service';
import { HttpClientModule } from '@angular/common/http';
import { TchekOldService } from './service/tchek-old.service';
import { NotificationService } from './service/notification.service';
import { ContactService } from './service/contact.service';
import { TokenInterceptor } from './service/token.interceptor';
import { AuthGuardService } from './service/auth.guard';
import { AdminGuardService } from './service/admin.guard';
import { AuthService } from './service/auth.service';
import { TraceService } from './service/trace.service';
import { ParseService } from './service/parse.service';
import { ParseFunctionService } from './service/parsefunction.service';
import { Globals } from './GlobalsExport';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import localeFr from '@angular/common/locales/fr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileBoxComponent } from './element/profile-box/profile-box.component';
import { AlertBoxComponent } from './element/alert-box/alert-box.component';
import { LatestTchekBoxComponent } from './element/latest-tchek-box/latest-tchek-box.component';
import { StatisticsBoxComponent } from './element/statistics-box/statistics-box.component';
import { MonitoringBoxComponent } from './element/monitoring-box/monitoring-box.component';
import { AwsService } from './service/aws.service';
import { ParamsComponent } from './params/params.component';
import { UtilService } from './service/util.service';
import { TRANSLATIONS, TRANSLATIONS_FORMAT } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { RoiService } from './service/roi.service';
import { SearchService } from './service/search.service';
import { FinderComponent } from './element/finder/finder.component';
import { SubscriptionService } from './service/subscription.service';
import { CacheService } from './service/cache.service';
import { DetectionProgressComponent } from './element/detection-progress/detection-progress.component';
import { RoiComponent } from './roi/roi.component';
import { AnnotationsComponent } from './annotations/annotations.component';
import { DatepickerComponent } from './element/datepicker/datepicker.component';

import { NgSelectModule } from '@ng-select/ng-select';

import { TchekListComponent } from './element/tchek-list/tchek-list.component';
import { AddStatsModalComponent } from './add-stats-modal/add-stats-modal.component';
import { ReportsStatsComponent } from './stats/reports-stats/reports-stats.component';
import { ReportsMonitorComponent } from './stats/reports-monitor/reports-monitor.component';
import { AlertsComponent } from './stats/alerts/alerts.component';
import { SummaryComponent } from './stats/summary/summary.component';
import { ReportComponent } from './report/report.component';
import { ReportSummaryComponent } from './element/report-summary/report-summary.component';
import { ReportScrollspyComponent } from './element/report-scrollspy/report-scrollspy.component';
import { PipeModule } from './pipe.module';
import { ScrollSpyDirective } from './directive/scroll-spy.directive';
import { DamageAnalysisComponent } from './element/damage-analysis/damage-analysis.component';
import { SignatoryComponent } from './element/signatory/signatory.component';
import { VehicleComponent } from './element/vehicle/vehicle.component';
import { VehicleDescriptionComponent } from './element/vehicle-description/vehicle-description.component';
import { ChecklistComponent } from './element/checklist/checklist.component';
import { InteriorComponent } from './element/interior/interior.component';
import { TiresComponent } from './element/tires/tires.component';
import { PreselectionComponent } from './element/preselection/preselection.component';
import { ReportDetailsComponent } from './element/report-details/report-details.component';
import { ReportHeaderComponent } from './element/report-header/report-header.component';
import { FluidContainerDirective } from './directive/fluid-container.directive';
import { ContentLoaderModule } from '@netbasal/ngx-content-loader';
import { ReportService } from './service/report.service';
import { EditValueModalComponent } from './edit-value-modal/edit-value-modal.component';
import { SubmenuComponent } from './element/submenu/submenu.component';
import { PdfService } from './service/pdf.service';
import { DamageService } from './service/damage.service';
import { VehicleLocationPipe } from './pipes/vehicle-location.pipe';
import { VehicleDamagePipe } from './pipes/vehicle-damage.pipe';
import { VehicleService } from './service/vehicle.service';
import { TchekService } from './service/tchek.service';
import { TchekStatusPipe } from './pipes/tchek-status.pipe';
import { AnimationComponent } from './animation/animation.component';
import { CanvasComponent } from './element/canvas/canvas.component';
import { RoiDrawerComponent } from './element/roi-drawer/roi-drawer.component';
import { AnnotationDrawerComponent } from './element/annotation-drawer/annotation-drawer.component';
import { AnnotationEditModalComponent } from './element/annotation-edit-modal/annotation-edit-modal.component';
import { RoiEditModalComponent } from './element/roi-edit-modal/roi-edit-modal.component';
import { ComparisonModalComponent } from './element/comparison-modal/comparison-modal.component';
import { VehicleAnglesComponent } from './element/vehicle-angles/vehicle-angles.component';
import { DelConfModalComponent } from './element/del-conf-modal/del-conf-modal.component';
import { ImageModalComponent } from './element/image-modal/image-modal.component';
import { AnnotationService } from './service/annotation.service';
import { FolderService } from './service/folder.service';
import { TagInputModule } from 'ngx-chips';
import { ParametersComponent } from './parameters/parameters.component';
import { ParametersScrollspyComponent } from './element/parameters-scrollspy/parameters-scrollspy.component';
import { ParametersReportsComponent } from './element/parameters-reports/parameters-reports.component';
import { ParametersOptionsComponent } from './element/parameters-options/parameters-options.component';
import { ParametersUsersComponent } from './element/parameters-users/parameters-users.component';
import { ParametersCostComponent } from './element/parameters-cost/parameters-cost.component';
import { ParametersNotificationsComponent } from './element/parameters-notifications/parameters-notifications.component';
import { ParametersLanguageComponent } from './element/parameters-language/parameters-language.component';
import { ParametersApiwebhookComponent } from './element/parameters-apiwebhook/parameters-apiwebhook.component';
import { ParametersHeaderComponent } from './element/parameters-header/parameters-header.component';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { MonitoringCardComponent } from './element/monitoring-card/monitoring-card.component';
import { ParametersService } from './service/parameters.service';
import { MonitoringService } from './service/monitoring.service';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { RoiEditModalV2Component } from './element/roi-edit-modal-v2/roi-edit-modal-v2.component';
import { VehicleSeverityPipe } from './pipes/vehicle-severity.pipe';
import { VehicleLocationPcPipe } from './pipes/vehicle-location-pc.pipe';
import { ParametersStyleComponent } from './element/parameters-style/parameters-style.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { SaveToastComponent } from './element/save-toast/save-toast.component';
import { ToastService } from './service/toast.service';
import { FinderAdminComponent } from './element/finder-admin/finder-admin.component';
import { SelectDropdownComponent } from './element/select-dropdown/select-dropdown.component';
import { RedirectPlayerComponent } from './element/redirect-player/redirect-player.component';
import { ParametersVehicleComponent } from './element/parameters-vehicle/parameters-vehicle.component';
import { ThumbnailDamageComponent } from './element/thumbnail-damage/thumbnail-damage.component';
import { ThumbnailService } from './service/thumbnail.service';
import { TchekLastScanComponent } from './element/tchek-last-scan/tchek-last-scan.component';
import { ScrollSpyMenuDirective } from './directive/scroll-spy-menu.directive';
import { LogsService } from './service/logs.service';
import { DndListModule } from 'ngx-drag-and-drop-lists';
import { RedirectDeviceLocalIpComponent } from './element/redirect-device-local-ip/redirect-device-local-ip.component';
import { ParametersUserComponent } from './element/parameters-user/parameters-user.component';
import { ParametersCompanyComponent } from './element/parameters-company/parameters-company.component';
import { SignaturePadModule } from 'angular2-signaturepad'
import { DropdownFilterDamageComponent } from './element/dropdown-filter-damage/dropdown-filter-damage.component';
import { ClassificationComponent } from './element/classification/classification.component';
import { ClassificationService } from './service/classification.service';
import { AngularDraggableModule } from 'angular2-draggable';
import { ParametersAccessibilityComponent } from './element/parameters-accessibility/parameters-accessibility.component';
import { LocalstorageService } from './service/localstorage.service';
import { ExportKpiComponent } from './element/export-kpi/export-kpi.component';
import { ModalIaComponent } from './element/modal-ia/modal-ia.component';
import { DamageSizeRangePipe } from './pipes/damage-size-range.pipe';
import { DamageAnalysisFilterComponent } from './element/damage-analysis-filter/damage-analysis-filter.component';
import { DamageFilterService } from './damage-filter.service';
import { ImageCropperModule } from 'ngx-image-cropper';
import { VehicleSvgComponent } from './element/vehicle-svg/vehicle-svg.component';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { DetectionComponent } from './detection/detection.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ImagesService } from './service/images.service';
import { NewTchekComponent } from './element/new-tchek/new-tchek.component';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { SuperAdminGuardService } from './service/superAdmin.guard';
import { ImageClassificationComponent } from './element/image-classification/image-classification.component';
import { DamageControlComponent } from './damage-control/damage-control.component';
import { MicroCanvasComponent } from './damage-control/micro-canvas/micro-canvas.component';
import { CanvasDetectionComponent } from './detection/canvas-detection/canvas-detection.component';
import { SupportComponent } from './support/support.component';
import { GenericToggleComponent } from './element/generic-toggle/generic-toggle.component';
import { VinscannerComponent } from './vinscanner/vinscanner.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ParametersCheckListComponent } from './element/parameters-check-list/parameters-check-list.component';
import { ReportCheckListComponent } from './element/report-check-list/report-check-list.component';
import { AnnexPictureComponent } from './element/annex-picture/annex-picture.component';
import { CanvasImageprocessingComponent } from './detection/canvas-imageprocessing/canvas-imageprocessing.component';

const translations = require(`raw-loader!../i18n/messages-en.xtb`).default;

registerLocaleData(localeFr);

@NgModule({
  imports: [
    // Tags inside inputs feature
    TagInputModule,
    BrowserModule,
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    BrowserAnimationsModule,
    PipeModule.forRoot(),
    // Custom dropdown features
    // Content loading placeholder feature
    ContentLoaderModule,
    FormsModule,
    NgxDaterangepickerMd.forRoot(),
    ColorPickerModule,
    DndListModule,
    SignaturePadModule,
    NgSelectModule,
    AngularDraggableModule,
    ImageCropperModule,
    DeviceDetectorModule.forRoot(),
    NgxDropzoneModule,
    Ng2ImgMaxModule,
    ZXingScannerModule
    // InMemoryWebApiModule.forRoot(InMemoryDataService)
  ],
  declarations: [
    AppComponent,
    routingComponents,
    HeaderComponent,
    FooterComponent,
    SearchComponent,
    ContactComponent,
    DashboardComponent,
    ProfileBoxComponent,
    AlertBoxComponent,
    LatestTchekBoxComponent,
    StatisticsBoxComponent,
    MonitoringBoxComponent,
    ParamsComponent,
    FinderComponent,
    DetectionProgressComponent,
    RoiComponent,
    AnnotationsComponent,
    DatepickerComponent,
    TchekListComponent,
    AddStatsModalComponent,
    ReportsStatsComponent,
    ReportsMonitorComponent,
    AlertsComponent,
    SummaryComponent,
    ReportComponent,
    ReportSummaryComponent,
    ReportScrollspyComponent,
    ScrollSpyDirective,
    DamageAnalysisComponent,
    SignatoryComponent,
    VehicleComponent,
    VehicleDescriptionComponent,
    ChecklistComponent,
    InteriorComponent,
    TiresComponent,
    PreselectionComponent,
    ReportDetailsComponent,
    ReportHeaderComponent,
    FluidContainerDirective,
    EditValueModalComponent,
    SubmenuComponent,
    VehicleLocationPipe,
    VehicleDamagePipe,
    TchekStatusPipe,
    AnimationComponent,
    CanvasComponent,
    RoiDrawerComponent,
    classificationImageToggleComponent,
    AnnotationDrawerComponent,
    AnnotationEditModalComponent,
    RoiEditModalComponent,
    ComparisonModalComponent,
    VehicleAnglesComponent,
    DelConfModalComponent,
    ImageModalComponent,
    ParametersComponent,
    ParametersScrollspyComponent,
    ParametersReportsComponent,
    ParametersOptionsComponent,
    ParametersUsersComponent,
    ParametersCostComponent,
    ParametersNotificationsComponent,
    ParametersLanguageComponent,
    ParametersApiwebhookComponent,
    ParametersHeaderComponent,
    MonitoringComponent,
    MonitoringCardComponent,
    RoiEditModalV2Component,
    VehicleSeverityPipe,
    VehicleLocationPcPipe,
    ParametersStyleComponent,
    SaveToastComponent,
    FinderAdminComponent,
    SelectDropdownComponent,
    DropdownFilterDamageComponent,
    RedirectPlayerComponent,
    ParametersVehicleComponent,
    ThumbnailDamageComponent,
    TchekLastScanComponent,
    ScrollSpyMenuDirective,
    RedirectDeviceLocalIpComponent,
    ParametersUserComponent,
    ParametersCompanyComponent,
    ClassificationComponent,
    ParametersAccessibilityComponent,
    ExportKpiComponent,
    ModalIaComponent,
    DamageSizeRangePipe,
    DamageAnalysisFilterComponent,
    VehicleSvgComponent,
    DetectionComponent,
    NewTchekComponent,
    ImageClassificationComponent,
    DamageControlComponent,
    MicroCanvasComponent,
    CanvasDetectionComponent,CanvasImageprocessingComponent,
    SupportComponent,
    GenericToggleComponent,
    VinscannerComponent,
    ParametersCheckListComponent,
    ReportCheckListComponent,
    AnnexPictureComponent,
  ],
  exports: [
    VehicleLocationPipe,
    VehicleDamagePipe,
    VehicleSeverityPipe
  ],
  providers: [
    I18n,
    {
      provide: TRANSLATIONS,
      useFactory: locale => {
        locale = locale || 'en'; // default to english if no locale provided
        return require(`raw-loader!../i18n/messages-${locale}.xtb`);
      },
      deps: [LOCALE_ID]
    },
    { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
    {
      provide: HTTP_INTERCEPTORS,
      useValue: 'fr',
      useClass: TokenInterceptor,
      multi: true
    },
    Globals,
    DatePipe,
    AuthGuardService, AdminGuardService, SuperAdminGuardService,
    AuthService,
    ParseService,
    UserService,
    FastTrackService,
    TchekOldService,
    VehicleService,
    NotificationService,
    ContactService,
    ParseFunctionService,
    AwsService,
    UtilService,
    TraceService,
    RoiService,
    SearchService,
    ClassificationService,
    SubscriptionService,
    CacheService,
    ReportService,
    PdfService,
    DamageService,
    VehicleDamagePipe,
    VehicleLocationPipe,
    TchekService,
    AnnotationService,
    FolderService,
    ParametersService,
    MonitoringService,
    VehicleSeverityPipe,
    VehicleLocationPcPipe,
    ToastService,
    ThumbnailService,
    LogsService,
    LocalstorageService,
    DamageFilterService,
    ImagesService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts